import { render, staticRenderFns } from "./kindChooseViewtk.vue?vue&type=template&id=4dc6d27e&scoped=true"
import script from "./kindChooseViewtk.vue?vue&type=script&lang=js"
export * from "./kindChooseViewtk.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewtk.vue?vue&type=style&index=0&id=4dc6d27e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc6d27e",
  null
  
)

export default component.exports